import templateUrl from "emun.auth/register-choice-prompt.htm";

import registerRetailerPrompt from "emun.auth/register-retailer.prompt";
import registerCurrentAccountPrompt from "emun.auth/register-current-acct-prompt";

import open from "webmodals/open";
import $session from "servicestack/session";
import ModalController from "webmodals/modal.controller";

export class RegisterChoicePromptController extends ModalController {
  constructor($uibModalInstance, options) {
    super($uibModalInstance);
    let $ctrl = this;
    $ctrl.bus = $session.bus;
    $ctrl.title = options.title || "Sign in to your account...";
  }

  registerRetailer() {
    let $ctrl = this;
    $ctrl.$dismiss("register");
    return registerRetailerPrompt({});
  }

  registerCurrentAccount() {
    let $ctrl = this;
    $ctrl.$dismiss("register");
    return registerCurrentAccountPrompt({});
  }
}

let registerChoicePrompt = options => {
  let modalInstance = open({
    size: options.size || "md",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: RegisterChoicePromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default registerChoicePrompt;
